// extracted by css-extract-rspack-plugin
export default {"cls1":"Timer-cls1_e8g","cls2":"Timer-cls2_Q8Z Timer-cls1_e8g","darkDigits":"Timer-darkDigits_ym5"};